import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/AuthContext";

export default function StartChat() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const nicheKey = params.get("niche") || "";
    const storedNicheKey = sessionStorage.getItem("askwinn_funnel_niche") || "";
    const storedLabel = sessionStorage.getItem("askwinn_funnel_niche_label") || "";
    const storedSector = sessionStorage.getItem("askwinn_pending_sector") || "";
    const knownSector = nicheKey && storedNicheKey === nicheKey ? (storedLabel || storedSector) : "";

    const redirect = (sector) => {
      if (cancelled) return;
      if (!sector) {
        nav("/start", { replace: true });
        return;
      }
      sessionStorage.setItem("askwinn_pending_sector", sector);
      localStorage.setItem("askwinn_desired_role", "buyer");
      nav(`/login?redirect=${encodeURIComponent(`/rfqs/new?sector=${sector}`)}`, { replace: true });
    };

    if (knownSector) {
      redirect(knownSector);
      return () => { cancelled = true; };
    }

    if (!nicheKey) {
      redirect(storedSector || storedLabel);
      return () => { cancelled = true; };
    }

    axios.get(`${API}/niches/${encodeURIComponent(nicheKey)}`)
      .then(({ data }) => redirect(data?.label))
      .catch(() => redirect(""));

    return () => { cancelled = true; };
  }, [nav, params]);

  return null;
}
